import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    imports: [RouterLink, MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnDestroy {
    private destroy$ = new Subject<void>();

    // isToggled
    isToggled = false;

    // Password Hide
    hide = true;
    hide2 = true;

    constructor(
        public themeService: CustomizerSettingsService
    ) {
        this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }


    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

}